<template>
  <v-app id="inspire">
    <Header type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-11">
            <div v-if="isLoadingReport" style="position:absolute; left:42%; 
              top: 40vh;
              display: flex;
              align-items: center;
              justify-content: center;
          ">
            <v-progress-circular
              color="green"
              indeterminate
              style="width:200px; height:200px; z-index:999;"
            ></v-progress-circular>
          </div>
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Отчеты</div>
                  <div class="breadcrumb" ref="myBtn">Отчеты</div>
                </div>
              </v-col>

              <v-col cols="12">
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="reportTab"
                      centered
                      class="reports-tabs"
                      height="40"
                  >
                    <v-tab v-for="item in reportType" :key="item.id" class="ml-4">
                      {{ item.name }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
              </v-col>
              <v-col>
                <v-tabs-items v-model="reportTab">

                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left" style="display:flex; align-items: center;">
                              <div>Касса</div>
                              <v-select
                                  v-model="select_cashbox"
                                  :items="listCashbox"
                                  item-text="legal_entity"
                                  item-value="serial"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  no-data-text="Кассы не найдены"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  color="#629F33"
                                  return-object
                                  background-color="#fff"
                                  style="max-width: 240px !important; margin:0px 20px;"
                              ></v-select>

                            <VueDatePicker no-title no-header v-model="filter.date"
                                           @onChange="typeToDate(filter.date)" color="#629f34"
                                           style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>
                            <v-btn dark class="filter-button" @click="reportGenerate('cashier')"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
              
                        </div>
                      </v-card-title>
                  
                    </v-sheet>
                  </v-tab-item>

                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(2)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(2)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          

                                <!-- <div v-if="newclient_id" style="cursor: pointer; color:red; margin-left:20px;" @click="newclient_id = null"> X </div> -->

                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search12"
                                    v-model="newclient_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                  </div>

                          </div>

                            <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                    >
                                    Выбор продавца
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                  </div>


                              </div>

                              <div class="item" style="margin-right: 10px; display:flex; margin-left:20px;  margin-top: 20px; flex-direction: column; width:25%;">


                                  <v-select
                                              class="rounded-lg custom__select"
                                              v-model="lastManager"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать исполнителя"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              return-object
                                              @change="setManager"
                                              style="height: 48px; max-width: 100%; width: 100%">
                                          </v-select>

                                  <div v-for="(line,index) of managerList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="setManager(line)"> X </div>
                                  </div>

                                </div>

                                
                                <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedNomenclature = null, nomenclatureModal = true, searchService = null"
                                    >
                                    Выбор номеклатуры
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of nomenclatureList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearNomenclature(line)"> X </div>
                                  </div>


                                </div>

                                <!-- <div class="item" style="margin-right: 10px; display:flex; align-items: center; margin-left:0px; width:25%;">
                                      <div v-if="filter.status_ext" style="cursor: pointer; color:red; margin-right:10px;" @click="filter.status_ext = null"> X </div>

                                              <v-select
                                                          class="rounded-lg custom__select"
                                                          v-model="filter.status_ext"
                                                          :items="statuses_ext"
                                                          item-value="id"
                                                          item-text="name"
                                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                                          placeholder="Статус продления"
                                                          append-icon="mdi-chevron-down"
                                                          outlined
                                                          dense
                                                          style="height: 48px;margin-top: 10px; width: 100%">
                                                      </v-select>
                                    </div> -->


                        </div>
                      </v-card-title>

                      <div class="scroll-table">
                        <table id="table-1" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="no-wrap" style="width:50%;">Структурная ед.</th>
                            <th colspan="2">Продажи</th>
                            <th colspan="2">Возвраты</th>
                            <th colspan="2" class="no-wrap">Продажи с учетом возвратов</th>
                            <th colspan="3">Оплачено</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th>Номенклатура</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th>Количество</th>
                            <th>Стоимость</th>
                            <th class="font-bold">Количество</th>
                            <th class="font-bold">Стоимость</th>
                            <th>Оплата</th>
                            <th class="no-wrap">Возврат оплаты</th>
                            <th class="font-bold">Оплата с уч-м возвратов</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th colspan="" style="display:flex; justify-content: space-around;">
                              <div>Клиент</div>
                              <div>Телефон</div>
                              <div>Менеджер</div>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <template >
                            <template v-for="(line,ind) of report_new_2.column1">
                              <tr class="parrent"
                              :key="'0-'+ind">
                                <td>
                                  <template v-if="Object.keys(line.column2).length > 0">

                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.res.column1.id) }"
                                        @click="openChildren(line.res.column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line.res.column1.name }}</td>
                                <td>{{ line.res.line1 ? line.res.line1.quantity : 0 }}</td>
                                
                                <td class="no-wrap">{{ line.res.line1 ? line.res.line1.sum : 0 }} ₽</td>
                                
                                <td>{{ line.res.line2 ? line.res.line2.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line2 ? line.res.line2.sum : 0 }} ₽</td>
                                <td>{{ line.res.line3 ? line.res.line3.quantity : 0 }}</td>
                                <td class="no-wrap">{{ line.res.line3.sum }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.refund }} ₽</td>
                                <td class="no-wrap">{{ line.res.line4.payment_including_return }} ₽
                                </td>
                              </tr>
                              <template v-if="Object.keys(line.column2).length > 0">
                                <template v-for="(children, index) of line.column2">
                                  <tr v-if="openParentLine.includes(line.res.column1.id)"
                                      :key="'01-'+index"
                                      :class="{ children: true, open: openParentLine.includes(line.res.column1.id) }">

                                    <td>
                                      <template v-if="children.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(children[0].column2.id) }"
                                            @click="openChildren(children[0].column2.id)"></button>
                                      </template>
                                    </td>

                                    <td>{{ children[0].column2.name }}</td>
                                    <td>{{ children[0].line1.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line1.sum }} ₽
                                    </td>
                                    <td>{{ children[0].line2.quantity }}</td>
                                    <td class="no-wrap">{{ children[0].line2.sum }}
                                      ₽
                                    </td>
                                    <td>{{
                                        children[0].line3.quantity
                                      }}
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line3.sum
                                      }} ₽
                                    </td>
                                    <td>{{ children[0].line4.payment }}</td>
                                    <td class="no-wrap">{{
                                        children[0].line4.return
                                      }} ₽
                                    </td>
                                    <td class="no-wrap">{{
                                        children[0].line4.payment_including_return
                                      }} ₽
                                    </td>
                                  </tr>

                                  <template v-if="children.length > 0">
                                    <template v-for="(children2, index2) of children">
                                      <tr v-if="openParentLine.includes(children[0].column2.id) && index2 !== 0"
                                          :key="'001-'+index2"
                                          :class="{ children: true, open: openParentLine.includes(children[0].column2.id) }">

                                        <td>
                                  
                                        </td>

                                        <td>
                                          <div style="display:flex; justify-content: space-around;">

                                            <router-link
                                                v-if="children2.column3 && children2.column3.client && children2.column3 && children2.column3.client.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: children2.column3.client.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('12')">{{ children2.column3.client.name }}</span>
                                            </router-link>
                                            <div v-else></div>
                                                
                                            <div style="">{{ (children2.column3 && children2.column3.phone) ? children2.column3.phone : '' }}</div>
                                            <div>{{ (children2.column3 && children2.column3.manager) ? children2.column3.manager.name : '' }} </div>

                                          </div>
                                        </td>
                                        <td>{{ children2.line1.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line1.sum }} ₽
                                        </td>
                                        <td>{{ children2.line2.quantity }}</td>
                                        <td class="no-wrap">{{ children2.line2.sum }}
                                          ₽
                                        </td>
                                        <td>{{
                                            children2.line3.quantity
                                          }}
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line3.sum
                                          }} ₽
                                        </td>
                                        <td>{{ children2.line4.payment }}</td>
                                        <td class="no-wrap">{{
                                            children2.line4.return
                                          }} ₽
                                        </td>
                                        <td class="no-wrap">{{
                                            children2.line4.payment_including_return
                                          }} ₽
                                        </td>
                                      </tr>
                                    </template>
                                  </template>

                                </template>
                              </template>
                            </template>
                            <tr class="parrent" v-if="report_new_2 && report_new_2.column1">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line1.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line1.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line2.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line2.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line3.quantity}}</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line3.sum}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.payment}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.refund}} ₽</td>
                              <td class="font-bold">{{report_new_2.column1[Object.keys(report_new_2.column1)[0]].res.line4.payment_including_return}} ₽</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>

                  
                  <!-- Движение по лицевым счетам -->
                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                      
                            <v-btn dark class="filter-button" @click="reportGenerate(3)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(3)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">
                        <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">

                              
                                    <v-autocomplete
                                          colspan="1"
                                          :items="(listClient && listClient.client) ? listClient.client : []"
                                          item-value="client_id"
                                          item-text="name"
                                          placeholder="Поиск клиентов"
                                          hide-no-data
                                          :search-input.sync="search13"
                                          v-model="newclient_id13"
                                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                          :no-filter=true
                                          class="rounded-lg"
                                          append-icon=""
                                          hide-details
                                          outlined
                                          dense
                                          background-color="white"
                                          style="height: 48px;padding-top: 5px; width: 100% !important; margin-left:10px;"
                                          required
                                      >
                                        <template v-slot:prepend-inner>
                                          <v-icon>mdi-magnify</v-icon>
                                        </template>

                                        <template v-slot:item=" { item } ">
                                          <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                            {{ item.name }} тел.:{{ item.phone }}
                                          </a>
                                        </template>
                                      </v-autocomplete>

                                      <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                            <div >{{ index+1 }}. {{line.name}}</div>
                                            <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                        </div>
                              </div>
                            </div>

                      </v-card-title>

         
                      <div class="scroll-table">
                        <table id="table-2" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="font-bold">Клиент</th>
                            <th class="font-bold">Сумма</th>
                            <th colspan="6" class="font-bold">Зачисления</th>
                            <th colspan="5" class="font-bold">Списания</th>
                            <th rowspan="2" class="font-bold no-wrap">Сумма Конечный остаток
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th class="font-bold">Лицевой счет</th>
                            <th class="font-bold">Начальный остаток</th>
                            <th class="font-bold">Всего (Зачисления)</th>
                            <th class="font-bold">Взнос</th>
                            <th class="font-bold">Возврат оплаты</th>
                            <th class="font-bold">Зачисление сертификата</th>
                            <th class="font-bold">Перемещение</th>
                            <th class="font-bold">Сумма прочее поступления</th>
                            <th class="font-bold">Всего (Списания)</th>
                            <th class="font-bold">Оплата</th>
                            <th class="font-bold">Возврат взноса</th>
                            <th class="font-bold">Перемещение</th>
                            <th class="font-bold">Сумма прочее списание</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_3 && report_new_3.length > 0">
                            <template v-for="(line,index) of report_new_3">
                              <tr class=""
                                :key="index"
                                v-if="line.result === false && line.children && line.children[0] && line.children[0].id"
                                >
                                <td>
                                  <template v-if="line.children && line.children.length > 0">
                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.column1.id) }"
                                        @click="openChildren(line.column1.id)"></button>
                                  </template>
                                </td>
                                <td>
                                  <router-link
                                                v-if="line.column1 && line.column1.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: line.column1.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  {{ line.column1.name }}
                                            </router-link>
                                            <div v-else></div>
                                </td>
                                <td>{{ line.line1_1 }}</td>
                                <td class="no-wrap">{{ line.line2_1 }} ₽</td>
                                <td>{{ line.line2_2 }}</td>
                                <td class="no-wrap">{{ line.line2_3 }} ₽</td>
                                <td>{{ line.line2_4 }}</td>
                                <td class="no-wrap">{{ line.line2_5 }} ₽</td>
                                <td class="no-wrap">{{ line.line2_6 }} ₽</td>
                                <td class="no-wrap">{{ line.line3_1 }} ₽</td>
                                <td class="no-wrap">{{ line.line3_2 ? line.line3_2 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_3 ? line.line3_3 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_4 ? line.line3_4 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_5 ? line.line3_5 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line4_1 }} ₽
                                </td>
                              </tr>
                              <template v-if="line.children && line.children.length > 0">
                                <template v-for="(children,index2) of line.children">
                                  <tr v-if="openParentLine.includes(line.column1.id)"
                                      :key="index+'0-0'+index2"
                                      :class="{ children: true, open: openParentLine.includes(line.column1.id) }">
                                    <td></td>
                                    <td>{{ children.name }}</td>
                                   <td>{{ line.line1_1 }}</td>
                                <td class="no-wrap">{{ line.line2_1 }} ₽</td>
                                <td>{{ line.line2_2 }}</td>
                                <td class="no-wrap">{{ line.line2_3 }} ₽</td>
                                <td>{{ line.line2_4 }}</td>
                                <td class="no-wrap">{{ line.line2_5 }} ₽</td>
                                <td class="no-wrap">{{ line.line2_6 }} ₽</td>
                                <td class="no-wrap">{{ line.line3_1 }} ₽</td>
                                <td class="no-wrap">{{ line.line3_2 ? line.line3_2 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_3 ? line.line3_3 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_4 ? line.line3_4 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line3_5 ? line.line3_5 : 0 }} ₽
                                </td>
                                <td class="no-wrap">{{ line.line4_1 }} ₽
                                </td>
                                  </tr>
                                  
                                </template>
                                
                              </template>
                              
                            </template>
                            <tr class="parrent" v-if="report_new_3 && report_new_3.length > 0">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{ report_new_3[0].line1_1 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_1 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_2 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_3 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_4}}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_5 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line2_6 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line3_1 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line3_2 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line3_3 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line3_4 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line3_5 }}</td>
                              <td class="font-bold">{{ report_new_3[0].line4_1 }}</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>

                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">

                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(4)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(4)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px;  width:25%;">

                            <div>Касса</div>
                                <v-select
                                    v-model="select_cashbox"
                                    :items="listCashbox"
                                    item-text="legal_entity"
                                    item-value="serial"
                                    class="rounded-lg"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    no-data-text="Кассы не найдены"
                                    outlined
                                    hide-details
                                    dense
                                    required
                                    color="#629F33"
                                    return-object
                                    background-color="#fff"
                                    style="max-width: 240px !important; margin:0px 20px;"
                                ></v-select>

                            </div>

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          
                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search14"
                                    v-model="newclient_id14"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px;width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                  </div>

                          </div>

                          <div class="item" style="width:26%; display:flex; align-items:center; margin-left:10px;">
                   
                            <div v-if="filter.uit" style="cursor: pointer; color:red; margin-right:10px;" @click="filter.uit = null"> X </div>
                            <v-select class="rounded-lg custom__select" v-model="filter.uit"
                                      :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                                      item-text="name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      placeholder="Подразделение" append-icon="mdi-chevron-down" outlined
                                      dense style="height: 48px;margin-top: 10px"
                                      >
                            </v-select>

                          </div>


                        </div>
                      </v-card-title>

                
                      <div class="scroll-table">
                        <table id="table-4" cellpadding="1">
                          <thead>
                          <tr>
                            <th class="font-bold">Дата</th>
                            <th class="font-bold">Номер</th>
                            <th class="font-bold">Клиент</th>
                            <th class="font-bold">Сумма</th>
                            <th class="font-bold">Оплачено</th>
                            <th class="font-bold no-wrap">Сумма возврата</th>
                            <th class="font-bold">Комментарий</th>
                            <th class="font-bold no-wrap">Структурная единица</th>
                            <th class="font-bold">Автор</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_4.length > 0">
                            <template v-for="(line,index) of report_new_4">
                              <tr class="" :key="index">
                                <td class="no-wrap td-check">
                                  <div>
                                    <template v-if="line.checked">
                                      <Icon iconName="check" width="16"
                                            height="16" viewBox="0 0 16 16"
                                            stroke="#629F33"/>
                                    </template>
                                    <template v-else>
                                      <Icon iconName="x" width="16" height="16"
                                            viewBox="0 0 16 16" stroke="#D53025"/>
                                    </template>
                                    {{ line.date }}
                                  </div>
                                </td>
                                <td>
                                  
                                  <router-link
                                                v-if="line.buy && line.buy.id"
                                                   :to="{name: 'Sale', params: {client: line.client, buy_id: line.buy.id, type: 'info'}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('14')">{{ line.number }}</span>
                                            </router-link>
                                            <div v-else>{{ line.number }}</div>
                                </td>
                                <td class="td-client">
                                  <div>
                                    <div class="ava">
                                      <img src="/playground_assets/Image-2.png"
                                           alt="">
                                    </div>

                                    <router-link
                                                v-if="line.client && line.client.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: line.client.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  <span @click="setReportParam('14')">{{ line.client.name }}</span>
                                            </router-link>
                                            <div v-else></div>
                                    
                                  </div>
                                </td>
                                <td class="no-wrap">{{ line.amount_sale }} ₽</td>
                                <td class="no-wrap">{{ line.amount_payment }} ₽</td>
                                <td class="no-wrap">{{ line.amount_payment_return }}</td>
                                <td class="no-wrap">{{ line.comment }}</td>
                                <td class="no-wrap">{{ line.org.name }}</td>
                                <td class="no-wrap">{{ line.author.name }}</td>
                              </tr>
                            </template>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>


                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">

                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(5)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(5)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">

           

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          
                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search15"
                                    v-model="newclient_id15"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px; padding-top:20px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                  </div>

                          </div>

                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; margin-left:20px; flex-direction: column; width:25%;">

                            <v-select
                                  v-if="rooms_list"
                                  v-model="room_id"
                                  class="rounded-lg custom__select"
                                  :items="rooms_list"
                                  item-value="id"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  color="#629F33"
                                  label="Выбрать помещение"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>

                          </div>


                        </div>
                      </v-card-title>

                      <div class="scroll-table">
                        <table id="table-5" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="font-bold">Клиент</th>
                            <th class="font-bold">Помещение</th>
                            <th colspan="" class="font-bold">Основание</th>
                            <th rowspan="2" class="font-bold no-wrap">Время
                            </th>
                            <th rowspan="2" class="font-bold no-wrap">Количество
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th class="font-bold">Дата</th>
                            <th class="font-bold">Вход</th>
                            <th colspan="2" class="font-bold">Выход</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_5 && report_new_5.length > 0">
                            <template v-for="(line,index) of report_new_5">
                              <tr class=""
                                :key="index"
                                v-if="line.result === false"
                                >
                                <td>
                                  <template v-if="Object.keys(line.children).length > 0 && line.result === false">
                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.column2.id) }"
                                        @click="openChildren(line.column2.id)"></button>
                                  </template>
                                </td>
                                <td>
                                  <router-link
                                                v-if="line.column2 && line.column2.id"
                                                    :to="{ name: 'CardClientNew', params: {client_id: line.column2.id}}"
                                                    class="d-flex"
                                                    style="align-items: center; text-decoration: none; color: #000"
                                                >
                                                  {{ line.column2.name }}
                                            </router-link>
                                            <div v-else></div>
                                </td>
                                <td>{{ line.column3.name }}</td>
                                <td>{{ line.column4.name }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              <template v-if="Object.keys(line.children).length > 0">
                                <template>
                                  <tr v-if="openParentLine.includes(line.column2.id) && line.result === false"
                                      :key="index+'0-02'"
                                      :class="{ children: true, open: openParentLine.includes(line.column2.id) }">
                                    <td></td>
                                    <td>{{ line.children.line1 }}</td>
                                    <td>{{ line.children.line2 }}</td>
                                    <td>{{ line.children.line3 }}</td>
                                    <td>{{ line.children.line4 }}</td>
                                    <td></td>
                                  </tr>
                                  
                                </template>
                                
                              </template>
                              
                            </template>
                            <tr class="parrent" v-if="report_new_5 && report_new_5.length > 0">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold"></td>
                              <td class="font-bold"></td>
                              <td class="font-bold">{{report_new_5[0].line4}}</td>
                              <td class="font-bold">{{report_new_5[0].line5}}</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>


                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <div class="left">
                          
                            <VueDatePicker 
                            no-title
                            no-header 
                            v-model="filter.date"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker>

                            <v-btn dark class="filter-button" @click="reportGenerate(6)"
                                   :disabled="buttonDisabled">
                              Сформировать
                            </v-btn>
                          </div>
                          <div class="right">
                            <v-btn light class="special-light-button" :disabled="buttonDisabled"
                            @click="reportExport(6)">
                              <img src="/playground_assets/printer.svg" alt="">
                              Печать
                            </v-btn>
                          </div>
                        </div>
                        <div class="report-1 filter" style="align-items: baseline;">
              
                          <div class="item" style="margin-right: 10px; display:flex;  margin-top: 20px; flex-direction: column; width:25%;">
                          
                                <v-autocomplete
                                    colspan="1"
                                    :items="(listClient && listClient.client) ? listClient.client : []"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск клиентов"
                                    hide-no-data
                                    :search-input.sync="search16"
                                    v-model="newclient_id16"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                    :no-filter=true
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined
                                    dense
                                    background-color="white"
                                    style="height: 48px; width: 100% !important; margin-left:10px;"
                                    required
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>

                                  <template v-slot:item=" { item } ">
                                    <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                      {{ item.name }} тел.:{{ item.phone }}
                                    </a>
                                  </template>
                                </v-autocomplete>

                                <div v-for="(line,index) of clientList" style="display:flex; align-items: center; font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="changeUsername(line)"> X </div>
                                  </div>

                          </div>

                          <div class="item" style="margin-right: 10px; display:flex; margin-left:10px;  margin-top: 20px; flex-direction: column; width:25%;">

                                  <div style="height:48px;">
                                    <v-btn
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedGroupSpecialist = null, groupSpecialistModal = true, searchService = null"
                                    >
                                    Выбор продавца
                                    </v-btn>
                                  </div>

                                  <div v-for="(line,index) of groupSpecialistList" style="display:flex; align-items: center;font-size:15px; padding-left:10px;" :key="line.id">
                                      <div >{{ index+1 }}. {{line.name}}</div>
                                      <div style="cursor: pointer; color:red; margin-left:10px; width:50px; height:50px; display:flex; align-items:center;" @click="clearGroupSpecialist(line)"> X </div>
                                  </div>


                          </div>

                          <div class="item" style="width:26%; display:flex; align-items:center; margin-left:10px;">
                   
                            <div v-if="filter.uit" style="cursor: pointer; color:red; margin-right:10px;" @click="filter.uit = null"> X </div>
                            <v-select class="rounded-lg custom__select" v-model="filter.uit"
                                      :items="(departmentList && departmentList.department) ? departmentList.department : []" item-title="name" item-value="id"
                                      item-text="name"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      placeholder="Подразделение" append-icon="mdi-chevron-down" outlined
                                      dense style="height: 48px;margin-top: 10px"
                                      >
                            </v-select>

                          </div>


                        </div>
                      </v-card-title>

                      <div class="scroll-table">
                        <table id="table-5" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="font-bold">Подразделение</th>
               
                            <th rowspan="2" class="font-bold no-wrap">План продаж
                            </th>
                            <th rowspan="2" class="font-bold no-wrap">Факт продаж
                            </th>
                            <th rowspan="2" class="font-bold no-wrap">План выполнен
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th class="font-bold">Продавец</th>
                   
                          </tr>
                          </thead>

                          
                          <tbody>
                          <template v-if="report_new_6 && report_new_6.column1">
                            <template v-for="(line,index) of report_new_6.column1">
                              <tr class=""
                                :key="index"
                                >
                                <td>
                                  <template v-if="line.children && line.children.length > 0">
                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line[0].column1.id) }"
                                        @click="openChildren(line[0].column1.id)"></button>
                                  </template>
                                </td>
                                <td>{{ line[1].column1.name }}</td>
                                <td>{{ line[0].line1 }}</td>
                                <td>{{ line[0].line2 }}</td>
                                <td>{{ line[0].line3 ? 'да' : 'нет' }}</td>
                              </tr>
                              <template v-if="line.children && line.children.length > 0">
                                <template v-for="(children2,index2) of line.children">
                                  <tr v-if="openParentLine.includes(line[0].column1.id)"
                                      :key="index2+'0-062'"
                                      :class="{ children: true, open: openParentLine.includes(line[0].column1.id) }">
                                    <td></td>
                                    <td>{{ children2.column2.name }}</td>
                                    <td>{{ children2.line1 }}</td>
                                    <td>{{ children2.line2 }}</td>
                                    <td>{{ children2.line3 ? 'да' : 'нет' }}</td>
                                  </tr>
                                  
                                </template>
                                
                              </template>
                              
                            </template>
                            <tr class="parrent" v-if="report_new_6 && report_new_6.res && report_new_6.res.line2">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{report_new_6.res.line1}}</td>
                              <td class="font-bold">{{report_new_6.res.line2}}</td>
                              <td class="font-bold">{{report_new_6.res.line3 ? 'да' : 'нет' }}</td>
        
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>



                  <!-- <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="left d-flex">
                          <VueDatePicker
                              no-title
                              no-header
                              range
                              :rangeInputText="date.start === date.end ? '%d' : '%d - %d'"
                              format="DD MMMM"
                              color="#629f34"
                              v-model="date"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    right
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                                {{ date }}
                              </button>
                            </template>
                          </VueDatePicker>
                          <v-btn
                              dark
                              class="filter-button"
                              @click="reportGenerate(7)"
                              :disabled="buttonDisabled"
                          >
                            Сформировать
                          </v-btn>
                        </div>
                        <div class="right">
                          <v-btn light class="special-light-button" :disabled="buttonDisabled"
                          @click="reportExport(7)">
                            <img src="/playground_assets/printer.svg" alt="">
                            Печать
                          </v-btn>
                        </div>
                      </v-card-title>
                      <div class="scroll-table">
                        <table id="table-7" cellpadding="1">
                          <thead>
                          <tr>
                            <th class="font-bold">Подразделение</th>
                            <th class="font-bold">Основание</th>
                            <th class="font-bold">Тип</th>
                            <th class="font-bold">Сумма</th>

                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report_new_7 && report_new_7.length > 0">
                            <template v-for="(line,index) of report_new_7">
                              <tr class="" :key="index">
                                <td class="no-wrap td-check">
                                  <div>
                                    {{ line.column1 }}
                                  </div>
                                </td>
                                <td class="no-wrap td-check">
                                  <div>
                                    {{ line.column2 }}
                                  </div>
                                </td>
               
                                <td class="no-wrap">{{ line.type }}</td>
                                <td class="no-wrap">{{ line.sum}} ₽</td>
                              </tr>
                            </template>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item> -->


                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title class="d-flex justify-space-between align-center">
                        <div class="left d-flex">
                          <VueDatePicker
                              no-title
                              no-header
                              range
                              :rangeInputText="date.start === date.end ? '%d' : '%d - %d'"
                              format="DD MMMM"
                              color="#629f34"
                              v-model="date"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    right
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                                {{ date }}
                              </button>
                            </template>
                          </VueDatePicker>
                          <v-btn
                              dark
                              class="filter-button"
                              @click="reportGenerate(11)"
                              :disabled="buttonDisabled"
                          >
                            Сформировать
                          </v-btn>
                        </div>
                        <div class="right">
                          <v-btn light class="special-light-button" :disabled="buttonDisabled"
                              @click="reportExport(11)">
                            <img src="/playground_assets/printer.svg" alt="">
                            Печать
                          </v-btn>
                        </div>
                      </v-card-title>
                      <div class="scroll-table" v-if="headers.length > 0 && report.length > 0">
                        <table id="table-11" cellpadding="1">
                          <thead>
                          <tr>
                            <th></th>
                            <th class="font-bold no-wrap">{{ headers[0].title }}</th>
                            <th class="font-bold no-wrap">Платежная карта</th>
                            <th class="font-bold">Безналичные</th>
                            <th class="font-bold">Наличные</th>
                            <th class="font-bold">Лицевой счет</th>
                            <th class="font-bold">Итого</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th class="font-bold">{{ headers[1].title }}</th>
                            <th class="font-bold">Сумма</th>
                            <th class="font-bold">Сумма</th>
                            <th class="font-bold">Сумма</th>
                            <th class="font-bold">Сумма</th>
                            <th class="font-bold">Сумма</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="report.length > 0">
                            <template v-for="line of report">
                              <tr class="parrent" :key="'parent-' + line.id">
                                <td>
                                  <template v-if="line.childrens.length > 0">
                                    <button
                                        :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                        @click="openChildren(line.id)"
                                    ></button>
                                  </template>
                                </td>
                                <td>{{ line.name }}</td>
                                <td><span v-if="line.card !== 0">{{ line.card }} ₽</span></td>
                                <td class="no-wrap"><span v-if="line.noncash !== 0">{{ line.noncash }} ₽</span></td>
                                <td><span v-if="line.cash !== 0">{{ line.cash }} ₽</span></td>
                                <td><span v-if="line.bill !== 0">{{ line.bill }} ₽</span></td>
                                <td class="no-wrap">{{ line.card + line.noncash + line.cash + line.bill }} ₽</td>
                              </tr>
                              <template v-if="line.childrens.length > 0">
                                <template v-for="children of line.childrens">
                                  <tr v-if="openParentLine.includes(line.id)"
                                      :key="'children-' + children.id"
                                      :class="{ children: true, open: openParentLine.includes(line.id) }">
                                    <td></td>
                                    <td>{{ children.name }}</td>
                                    <td><span v-if="children.card !== 0">{{ children.card }} ₽</span></td>
                                    <td class="no-wrap"><span v-if="children.noncash !== 0">{{ children.noncash }} ₽</span></td>
                                    <td><span v-if="children.cash !== 0">{{ children.cash }} ₽</span></td>
                                    <td><span v-if="children.bill !== 0">{{ children.bill }} ₽</span></td>
                                    <td class="no-wrap">{{ children.card + children.noncash + children.cash + children.bill }} ₽</td>
                                  </tr>
                                </template>
                              </template>
                            </template>
                            <tr class="parrent">
                              <td></td>
                              <td class="font-bold">Итого</td>
                              <td class="font-bold">{{report_result.sum1}}</td>
                              <td class="font-bold">{{report_result.sum2}}</td>
                              <td class="font-bold">{{report_result.sum3}}</td>
                              <td class="font-bold">{{report_result.sum4}}</td>
                              <td class="font-bold">{{report_result.sum5}}</td>
        
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </v-sheet>
                  </v-tab-item>



                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row>
            <v-dialog
                  v-model="nomenclatureModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="nomenclatureModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>Номенклатура</h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="nomenclatureModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск номенклатуры"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearch"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.nomenclature_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.nomenclature_id = null"> X </div>
                      <div v-if="filter.nomenclature_id">{{filter.nomenclature_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="listAllServicesDef && listAllServicesDef.sales"
                    :items="listAllServicesDef.sales"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTree"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToNomenclatureParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToNomenclature(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveNomenclature"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

          <v-row>
            <v-dialog
                  v-model="groupSpecialistModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="groupSpecialistModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>Продавцы</h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="groupSpecialistModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск продавца"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearchGroup"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.group_specialist_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.group_specialist_id = null"> X </div>
                      <div v-if="filter.group_specialist_id">{{filter.group_specialist_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="specialistGroup && specialistGroup.specialistGroup"
                    :items="specialistGroup.specialistGroup"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTreeGroup"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToGroupSpecialistParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToGroupSpecialist(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <!-- <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span> -->
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveGroupSpecialist"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

      </v-container>
    </v-main>
    <!-- <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe> -->
  </v-app>
</template>
<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {reportActionTypes} from '@/store/modules/report';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {getItem, setItem} from "@/helpers/persistanceStorage";
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {clientActionTypes} from '@/store/modules/client';
import {lessonActionTypes} from "@/store/modules/lesson";
import {departmentActionTypes} from '@/store/modules/department';
import {salesActionTypes} from "@/store/modules/sale";
import {mapState} from "vuex";

export default {
  name: 'Reports',
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      date: {
        start: new Date(),
        end: new Date(),
      },
      months: [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь'
      ],
      headers: [],
      reportType: [
        {id: 0, name: 'Справка отчет кассира-операциониста (КМ-6)'},
        {id: 1, name: 'Продажа и оплаты'},
        {id: 2, name: 'Движения по лицевым счетам'},
        {id: 3, name: 'Продажи (Список)'},
        {id: 4, name: 'Посещение помещений'},
        {id: 5, name: 'Продажи план-факт'},
        {id: 7, name: 'Выручка по подразделениям'}
      ],
      reportTab: 0,
      itemsStrucuUit: [
        {title: 'Все организации', value: null},
        {title: 'ИП Сорокин Н.С.', value: "c1094ab2-dcc2-11ec-a062-60e32700ce56"},
        {title: 'ООО \"КлеверСпорт\"', value: "5738e017-5875-11ea-80e1-9c5c8e747603"}
      ],
      itemsClient: [
        {title: 'Ковалев А.Ю.', value: '1'},
        {title: 'Сидорова В.П.', value: '2'},
        {title: 'Самойлов К.И.', value: '3'},
      ],
      itemsDivision: [
        {title: 'Подразделение 1', value: '1'},
        {title: 'Подразделение 2', value: '2'},
        {title: 'Подразделение 3', value: '3'},
      ],
      filter: {
        date: new Date(),
        client: null,
        uit: null,
        division: null
      },
      buttonDisabled: false,
      reportData: [],
      reportData2: [],
      reportData3: [],
      report: [],
      openParentLine: [],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? [],
      select_cashbox: null,
      select_cashbox_id: null,
      report_new_2:[],
      report_new_3:[],
      report_new_4:[],
      report_new_5:[],
      report_new_6:[],
      report_new_7:[],
      isLoadingReport:false,
      newclient_id:null,
      newclient_id12:null,
        newclient_id13:null,
        newclient_id14:null,
        newclient_id15:null,
        newclient_id16:null,
        newclient_id17:null,
      search: '',
      search12: '',
      search13: '',
      search14: '',
      search15: '',
      search16: '',
      search17: '',
      rooms_list:[],
      room_id:null,
      departmentListDef:[],
      listAllServicesDef:null,
        uitList:[],
        lastUit:null,
        clientList:[],
        nomenclatureModal:false,
        nomenclatureList:[],
        managerList:[],
        lastManager:null,
        groupSpecialistModal:false,
        groupSpecialistList:[],
        searchService: null,
        report_result:[]
    }
  },
  computed: {
    ...mapState({
      listClient: state => state.client.listClient,
      departmentList: state => state.department.departmentList,
      specialist: state => state.lesson.specialist,
      specialistGroup: state => state.lesson.specialistGroup
    }),
    searchPackages() {
      let res = this.caseSensitive
        ? sayMyNane(item, search, textKey)
        : undefined

        function sayMyNane(item, search, textKey){
          (item[textKey2].indexOf(search) > -1)
        }

      return res

    },
  },
  methods: {
    handleSearch(input) {
      // //console.log(+input)
      // if(input && +input && +input != NaN){
      //   input = '('+(+input)
      // }
      if (input && input.length >= 2) {
        this.$refs.myTree.updateAll(true)
      } else {
        this.$refs.myTree.updateAll(false)
      }
    },
    handleSearchGroup(input) {
      // //console.log(+input)
      // if(input && +input && +input != NaN){
      //   input = '('+(+input)
      // }
      if (input && input.length >= 2) {
        this.$refs.myTreeGroup.updateAll(true)
      } else {
        this.$refs.myTreeGroup.updateAll(false)
      }
    },
    setManager(item){
        //console.log(item)
        if (this.managerList.findIndex(n => n.id === item.id) !== -1) {
          this.managerList.splice(this.managerList.findIndex(n => n.id === item.id),1);
        } else {
          this.managerList.push(item)
        }

        if(this.managerList.length === 0){
          this.lastManager = null
        }

      },
      setUit(item){
        //console.log(item)
        if (this.uitList.findIndex(n => n.id === item.id) !== -1) {
          this.uitList.splice(this.uitList.findIndex(n => n.id === item.id),1);
        } else {
          this.uitList.push(item)
        }

        if(this.uitList.length === 0){
          this.lastUit = null
        }

      },
      saveNomenclature(){

        let item = this.chosedNomenclature

        if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
          //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
          this.nomenclatureList.push(item)
        }

        this.nomenclatureModal = false
      },
      clearNomenclature(item){
        if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
          this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
        }
      },
      addToNomenclatureParent(itemar){
        //console.log('parent')
        //console.log(itemar)
        if(itemar.length === 0) {
          return;
        }

        this.chosedNomenclature = itemar[0]

        // let item = itemar[0]
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
      },  
      addToNomenclature(item){
        //console.log('child')
        //console.log(item)

        this.chosedNomenclature = item
   
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
      },  

      saveGroupSpecialist(){

        let item = this.chosedGroupSpecialist

        if (this.groupSpecialistList.findIndex(n => n.id === item.id) !== -1) {
          //this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        } else {
          this.groupSpecialistList.push(item)
        }

        this.groupSpecialistModal = false
        },
        clearGroupSpecialist(item){
        if (this.groupSpecialistList.findIndex(n => n.id === item.id) !== -1) {
          this.groupSpecialistList.splice(this.groupSpecialistList.findIndex(n => n.id === item.id),1);
        } else {
        }
        },
        addToGroupSpecialistParent(itemar){
        //console.log('parent2')
        //console.log(itemar)
        if(itemar.length === 0) {
          return;
        }

        this.chosedGroupSpecialist = itemar[0]

        // let item = itemar[0]
        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
        },  
        addToGroupSpecialist(item){
        //console.log('child')
        //console.log(item)

        this.chosedGroupSpecialist = item

        // if (this.nomenclatureList.findIndex(n => n.id === item.id) !== -1) {
        //   this.nomenclatureList.splice(this.nomenclatureList.findIndex(n => n.id === item.id),1);
        // } else {
        //   this.nomenclatureList.push(item)
        // }
        // //console.log(this.nomenclatureList)

        // if(this.nomenclatureList.length === 0){
        //   this.lastUit = null
        // }
        },  

    setReportParam(param){

      if(this.newclient_id) {
        setItem('report_newclient_id',this.newclient_id);

      }



      if(param === '12') {
        //console.log('set PARAMS')
        setItem('report_12',JSON.stringify(this.report_new_2));
        setItem('report_13',null);
        setItem('report_14',null);
        setItem('report_15',null);
        setItem('report_16',null);
        setItem('report_17',null);

        setItem('report_start',this.filter.date.start);
        setItem('report_end',this.filter.date.end);
        
      }

      if(param === '13') {
        setItem('report_13',JSON.stringify(this.report_new_3));
        setItem('report_12',null);
        setItem('report_14',null);
        setItem('report_15',null);
        setItem('report_16',null);
        setItem('report_17',null);
      }

      if(param === '14') {
        setItem('report_14',JSON.stringify(this.report_new_4));
        setItem('report_12',null);
        setItem('report_13',null);
        setItem('report_15',null);
        setItem('report_16',null);
        setItem('report_17',null);

        setItem('report_start',this.filter.date.start);
        setItem('report_end',this.filter.date.end);
      }

      if(param === '15') {
        setItem('report_15',JSON.stringify(this.report_new_5));
        setItem('report_12',null);
      setItem('report_13',null);
      setItem('report_14',null);
      setItem('report_16',null);
      setItem('report_17',null);
      }

      if(param === '16') {
        setItem('report_16',JSON.stringify(this.report_new_6));
        setItem('report_12',null);
      setItem('report_13',null);
      setItem('report_14',null);
      setItem('report_15',null);
      setItem('report_17',null);
      }

      if(param === '17') {
        setItem('report_17',JSON.stringify(this.report_new_7));
        setItem('report_12',null);
      setItem('report_13',null);
      setItem('report_14',null);
      setItem('report_15',null);
      setItem('report_16',null);
      }

      
    },
    changeUsername(item) {
        //console.log(item)
        
        if (this.clientList.findIndex(n => n.client_id === item.client_id) !== -1) {
          this.clientList.splice(this.clientList.findIndex(n => n.client_id === item.client_id),1);
        } else {
          this.clientList.push(item)
        }

        if(this.clientList.length === 0){
          this.newclient_id = null
        }

        this.newclient_id = null
        this.newclient_id2 = null
        this.newclient_id12 = null
        this.newclient_id13 = null
        this.newclient_id14 = null
        this.newclient_id15 = null
        this.newclient_id16 = null
        this.newclient_id17 = null

        this.search13 = null
        this.search14 = null
        this.search15 = null
        this.search16 = null
        this.search17 = null

        var elem = this.$refs.myBtn
        elem.click()

        //this.newclient_id = client

      },
    typeToDate(date) {
      this.$set(this.filter, 'date', new Date(date))
    },
    openChildren(id) {
      ////console.log(id)
      if (this.openParentLine.includes(id)) {
        ////console.log(id)
        this.$delete(this.openParentLine, this.openParentLine.indexOf(id))
      } else {
        ////console.log(id)
        this.$set(this, 'openParentLine', [...this.openParentLine, id])
      }
    },
    reportExport(type) {

      this.isLoadingReport = true

      if(type === 'cashier'){

        let select_cashbox_id = this.select_cashbox_id

        if(!select_cashbox_id){
          select_cashbox_id = 'be620393-fb55-11eb-a060-60e32700ce56'
        }


        // this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        //   till_id: '00108720010250'
        // }).then((resp) => {
        //     ////console.log(resp)
        //     if(resp && resp.cashbox) {
        //       } else {
        //     }
        // })



        ////console.log(this.filter.date)

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date,
          date_end: this.filter.date,
          cashbox_id:select_cashbox_id,
          type:'cashier',
          export:true
        })
        .then((response2) => {
          if(response2 && response2.success){
            let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'report_cashier' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                      this.isLoadingReport = false
          }
        })

      } else if(type === 2) {

        setItem('report_12',null);

        //this.report_new_2 = []

        let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }

            let managerListRes = []
            if(this.managerList.length > 0){
              for(let i = 0; i < this.managerList.length; i++){
                managerListRes.push(this.managerList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:(clientListRes.length > 0) ? clientListRes : [],
          group_specialist_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
          nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
          manager_id:(managerListRes.length > 0) ? managerListRes : [],
          type:2,
          export:true
        }).then((response) => {
          //this.headers = response.headers
          //this.report = response.revenue
          if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
        })

      } else if(type === 3) {

        setItem('report_13',null);

        //this.report_new_3 = []

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:this.newclient_id,
          type:3,
          export:true
        })
        .then((response) => {
          if(response && response.link){
                     //печатаем
                     let link = document.createElement('a');
                      link.href = response.link;
                      link.target = 'a_blank';
                      //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      //link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.isLoadingReport = false
          } else {
              alert('Данных не найдено!')
              this.isLoadingReport = false
          }
        })

      } else if(type === 4) {

        setItem('report_14',null);

          //this.report_new_4 = []

          let select_cashbox_id = this.select_cashbox_id

          if(!select_cashbox_id){
            select_cashbox_id = 'be620393-fb55-11eb-a060-60e32700ce56'
          }

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            filter:this.filter,
            org_id:this.filter.uit,
            cashbox_id:select_cashbox_id,
            type:4,
            export:true
          })
          .then((response) => {
            if(response && response.link){
                      //печатаем
                      let link = document.createElement('a');
                        link.href = response.link;
                        link.target = 'a_blank';
                        //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                        //link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        this.isLoadingReport = false
            } else {
                alert('Данных не найдено!')
                this.isLoadingReport = false
            }
          })

        } else if(type === 5) {

          setItem('report_15',null);

          //this.report_new_5 = []

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            type:5,
            room_id:this.room_id,
            export:true
          }).then((response) => {
                if(response && response.link){
                        //печатаем
                        let link = document.createElement('a');
                          link.href = response.link;
                          link.target = 'a_blank';
                          //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                          //link.setAttribute('download', filename);
                          document.body.appendChild(link);
                          link.click();
                          link.remove();
                          this.isLoadingReport = false
              } else {
                  alert('Данных не найдено!')
                  this.isLoadingReport = false
              }
          })
        } else if(type === 6) {


          setItem('report_16',null);

            //this.report_new_6 = []

            let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }


            this.$store.dispatch(reportActionTypes.revenueDivision, {
              date_start: this.filter.date.start,
              date_end: this.filter.date.end,
              client_id:(clientListRes.length > 0) ? clientListRes : [],
              manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
              org_id:this.filter.uit,
              type:6,
              export:true
            }).then((response) => {
                      if(response && response.link){
                            //печатаем
                            let link = document.createElement('a');
                              link.href = response.link;
                              link.target = 'a_blank';
                              //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                              //link.setAttribute('download', filename);
                              document.body.appendChild(link);
                              link.click();
                              link.remove();
                              this.isLoadingReport = false
                  } else {
                      alert('Данных не найдено!')
                      this.isLoadingReport = false
                  }
            })
          } else if(type === 7) {

            setItem('report_17',null);

              //this.report_new_7 = []

              this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                client_id:this.newclient_id,
                type:7,
                export:true
              })
              .then((response) => {

                if(response && response.link){
                              //печатаем
                              let link = document.createElement('a');
                                link.href = response.link;
                                link.target = 'a_blank';
                                //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                                //link.setAttribute('download', filename);
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                this.isLoadingReport = false
                    } else {
                        alert('Данных не найдено!')
                        this.isLoadingReport = false
                    }
              })

      } else {
        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.date.start,
          date_end: this.date.end,
          type:11,
          export:true
        })
        .then((response) => {
                  if(response && response.link){
                              //печатаем
                              let link = document.createElement('a');
                                link.href = response.link;
                                link.target = 'a_blank';
                                //let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                                //link.setAttribute('download', filename);
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                this.isLoadingReport = false
                    } else {
                        alert('Данных не найдено!')
                        this.isLoadingReport = false
                    }

        })
      }
      },
    reportGenerate(type) {

      this.isLoadingReport = true

      if(type === 'cashier'){

        let select_cashbox_id = this.select_cashbox_id

        if(!select_cashbox_id){
          select_cashbox_id = 'be620393-fb55-11eb-a060-60e32700ce56'
        }


        // this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        //   till_id: '00108720010250'
        // }).then((resp) => {
        //     ////console.log(resp)
        //     if(resp && resp.cashbox) {
        //       } else {
        //     }
        // })

   

        ////console.log(this.filter.date)

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date,
          date_end: this.filter.date,
          cashbox_id:select_cashbox_id,
          type:'cashier'
        })
        .then((response2) => {
          if(response2 && response2.success){
            let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'report_cashier' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                      this.isLoadingReport = false
          }
        })

      } else if(type === 2) {

        setItem('report_12',null);

        this.report_new_2 = []

        let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }

            let managerListRes = []
            if(this.managerList.length > 0){
              for(let i = 0; i < this.managerList.length; i++){
                managerListRes.push(this.managerList[i].id)
              }
            }
            let nomenclatureListRes = []
            if(this.nomenclatureList.length > 0){
              for(let i = 0; i < this.nomenclatureList.length; i++){
                nomenclatureListRes.push(this.nomenclatureList[i].id)
              }
            }

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:(clientListRes.length > 0) ? clientListRes : [],
          group_specialist_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
          nomenclature_id:(nomenclatureListRes.length > 0) ? nomenclatureListRes : [],
          manager_id:(managerListRes.length > 0) ? managerListRes : [],
          type:2
        })
        .then((response) => {
          //this.headers = response.headers
          //this.report = response.revenue
          if(response && response.success && response.success === true){
            this.report_new_2 = response.data
            this.isLoadingReport = false

          } else {
              alert('Ошибка формирования отчёта!')
              this.isLoadingReport = false
            }
        })

      } else if(type === 3) {

        setItem('report_13',null);

        this.report_new_3 = []

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:this.newclient_id,
          type:3
        })
        .then((response) => {
          //this.headers = response.headers
          //this.report = response.revenue
          if(response && response.success){
            this.report_new_3 = response.data
            this.isLoadingReport = false
          } else {
              alert('Ошибка формирования отчёта!')
              this.isLoadingReport = false
            }
        })

       } else if(type === 4) {

        setItem('report_14',null);

          this.report_new_4 = []

          let select_cashbox_id = this.select_cashbox_id

          if(!select_cashbox_id){
            select_cashbox_id = 'be620393-fb55-11eb-a060-60e32700ce56'
          }

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            filter:this.filter,
            org_id:this.filter.uit,
            cashbox_id:select_cashbox_id,
            type:4
          })
          .then((response) => {
            //this.headers = response.headers
            //this.report = response.revenue
            if(response && response.success){
              this.report_new_4 = response.data
              this.isLoadingReport = false
            } else {
              alert('Ошибка формирования отчёта!')
              this.isLoadingReport = false
            }
          })

        } else if(type === 5) {

          setItem('report_15',null);

          this.report_new_5 = []

          let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

          this.$store.dispatch(reportActionTypes.revenueDivision, {
            date_start: this.filter.date.start,
            date_end: this.filter.date.end,
            client_id:(clientListRes.length > 0) ? clientListRes : [],
            type:5,
            room_id:this.room_id
          })
          .then((response) => {
            //this.headers = response.headers
            //this.report = response.revenue
            if(response && response.success){
              this.report_new_5 = response.data
              this.isLoadingReport = false
            } else {
                alert('Ошибка формирования отчёта!')
                this.isLoadingReport = false
              }
          })
        } else if(type === 6) {


          setItem('report_16',null);

            this.report_new_6 = []

            let clientListRes = []
            if(this.clientList.length > 0){
              for(let i = 0; i < this.clientList.length; i++){
                clientListRes.push(this.clientList[i].client_id)
              }
            }

            let groupSpecialistListRes = []
            if(this.groupSpecialistList.length > 0){
              for(let i = 0; i < this.groupSpecialistList.length; i++){
                groupSpecialistListRes.push(this.groupSpecialistList[i].id)
              }
            }


            this.$store.dispatch(reportActionTypes.revenueDivision, {
              date_start: this.filter.date.start,
              date_end: this.filter.date.end,
              client_id:(clientListRes.length > 0) ? clientListRes : [],
              manager_id:(groupSpecialistListRes.length > 0) ? groupSpecialistListRes : [],
              org_id:this.filter.uit,
              type:6
            })
            .then((response) => {
              //this.headers = response.headers
              //this.report = response.revenue
              if(response && response.success){
                this.report_new_6 = response.data
                this.isLoadingReport = false
              } else {
                  alert('Ошибка формирования отчёта!')
                  this.isLoadingReport = false
                }
            })
          } else if(type === 7) {

            setItem('report_17',null);

              this.report_new_7 = []

              this.$store.dispatch(reportActionTypes.revenueDivision, {
                date_start: this.filter.date.start,
                date_end: this.filter.date.end,
                client_id:this.newclient_id,
                type:7
              })
              .then((response) => {

                if(response && response.success){
                  this.report_new_7 = response.data
                  this.isLoadingReport = false
                } else {
                    alert('Ошибка формирования отчёта!')
                    this.isLoadingReport = false
                  }
              })

      } else {
        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.date.start,
          date_end: this.date.end,
          type:11
        })
        .then((response) => {
          if(response && response.success){
            this.headers = response.headers
            this.report = response.revenue
            this.report_result = response.result_sum
            this.isLoadingReport = false
          } else {
            alert('Ошибка формирования отчёта!')
            this.isLoadingReport = false
          }
    
        })
      }
    },
    printTable(tableID) {
      const style = `<style>@media print {
        td:first-child,
        th:first-child {
            display: none;
        }
}</style>`
      window.frames["print_frame"].document.body.innerHTML = style + '<table>' + document.getElementById(tableID).innerHTML + '</table>';
      window.frames["print_frame"].window.focus();
      window.frames["print_frame"].window.print();
    }
  },
  mounted() {

    if(getItem('report_start') && getItem('report_start') !== null && getItem('report_start') !== 'null' && getItem('report_start') !== undefined){
      this.filter.date.start = getItem('report_start')
      this.filter.date.end = getItem('report_end')

      setItem('report_start',null)
      setItem('report_end',null)

    } else {
      this.filter.date.start = new Date()
      this.filter.date.end = new Date()
    }

    if(getItem('report_12') && getItem('report_12') !== null && getItem('report_12') !== 'null' && getItem('report_12') !== undefined){
      this.report_new_2 = JSON.parse(getItem('report_12'));
      this.reportTab = 1

      
    }

    if(getItem('report_13') && getItem('report_13') !== null && getItem('report_13') !== 'null' && getItem('report_13') !== undefined){
      this.report_new_3 = JSON.parse(getItem('report_13'));
      this.reportTab = 2

      //setItem('report_13',null)
    }

    if(getItem('report_14') && getItem('report_14') !== null && getItem('report_14') !== 'null' && getItem('report_14') !== undefined){
      this.report_new_4 = JSON.parse(getItem('report_14'));
      this.reportTab = 3

      setItem('report_14',null)
    }

    if(getItem('report_15') && getItem('report_15') !== null && getItem('report_15') !== 'null' && getItem('report_15') !== undefined){
      this.report_new_5 = JSON.parse(getItem('report_15'));
      this.reportTab = 4
    }

    if(getItem('report_16') && getItem('report_16') !== null && getItem('report_16') !== 'null' && getItem('report_1report_162') !== undefined){
      this.report_new_6 = JSON.parse(getItem('report_16'));
      this.reportTab = 5
    }

    if(getItem('report_17') && getItem('report_17') !== null && getItem('report_17') !== 'null' && getItem('report_17') !== undefined){
      this.report_new_7 = JSON.parse(getItem('report_17'));
      this.reportTab = 6
    }

    //console.log(getItem('report_newclient_id'))
    if(getItem('report_newclient_id') && getItem('report_newclient_id') !== null && getItem('report_newclient_id') !== 'null' && getItem('report_newclient_id') !== undefined){
      this.newclient_id = getItem('report_newclient_id')
    }

    this.$store.dispatch(lessonActionTypes.getSpecialistList);

    this.$store.dispatch(lessonActionTypes.getGroupSpecialistList);

  this.$store.dispatch(departmentActionTypes.departmentList).then((result) => {
      if(result){
        this.departmentListDef = result.department
      }
    })

    let org_inn = null
      this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn:org_inn,for_reports:true})
      .then((response) => {
        if(response && response.sales) {
          this.listAllServicesDef = response
        }
      })

    setItem('sale-client',null)

  },  
  watch: {
    search() {
      //this.newclient_id = null
      //console.log(this.search)
      if (this.search !== '' && !this.newclient_id) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      }
    },
    search12() {
      //this.newclient_id = null
      //console.log(this.search12)
      if (this.search12 !== '' && !this.newclient_id) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search12
        })
      }
    },
    search13() {
      //this.newclient_id = null
      //console.log(this.search13)
      if (this.search13 !== '' && !this.newclient_id13) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search13
        })
      }
    },
    search14() {
      //this.newclient_id = null
      //console.log(this.search14)
      if (this.search14 !== '' && !this.newclient_id14) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search14
        })
      }
    },
    search15() {
      //this.newclient_id = null
      //console.log(this.search15)
      if (this.search15 !== '' && !this.newclient_id15) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search15
        })
      }
    },
    search16() {
      //this.newclient_id = null
      //console.log(this.search16)
      if (this.search16 !== '' && !this.newclient_id16) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search16
        })
      }
    },
    reportTab() {


     

      this.newclient_id = null
      this.nomenclatureList = []
        this.uitList = []
        this.clientList = []
        this.managerList = []

        this.lastManager = null
        this.lastUit = null
        this.lastStatus = null

    if(getItem('report_12') && getItem('report_12') !== null && getItem('report_12') !== undefined && getItem('report_12') !== 'null') {
       setItem('report_12',null)
    } else {
      this.report_new_2 = []
    }

    if(getItem('report_13') && getItem('report_13') !== null && getItem('report_13') !== undefined && getItem('report_13') !== 'null') {
       setItem('report_13',null)
    } else {
      this.report_new_3 = []
    }

    // if(getItem('report_14') && getItem('report_14') !== null && getItem('report_14') !== undefined && getItem('report_14') !== 'null') {
    //    setItem('report_14',null)
    // } else {
    //   this.report_new_4 = []
    // }

    if(getItem('report_15') && getItem('report_15') !== null && getItem('report_15') !== undefined && getItem('report_15') !== 'null') {
       setItem('report_15',null)
    } else {
      this.report_new_5 = []
    }

    if(getItem('report_16') && getItem('report_16') !== null && getItem('report_16') !== undefined && getItem('report_16') !== 'null') {
       setItem('report_16',null)
    } else {
      this.report_new_6 = []
    }

    
      this.report_new_7 = []

      if (this.reportTab === 3) {
        this.report_new_4 = []

        this.$store.dispatch(reportActionTypes.revenueDivision, {
          date_start: this.filter.date.start,
          date_end: this.filter.date.end,
          client_id:this.newclient_id,
          filter:this.filter,
          type:4
        })
        .then((response) => {
          if(response && response.success){
            this.report_new_4 = response.data
            this.isLoadingReport = false
          } else {
            alert('Ошибка формирования отчёта!')
            this.isLoadingReport = false
          }
        })

        
        this.$store.dispatch(departmentActionTypes.departmentList).then((result) => {
          if(result){
            this.departmentListDef = result.department
          }
        })



      }

      if (this.reportTab === 4) {
        this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_reports: true
                  })
        .then((response) => {
          this.rooms_list = response.room
          this.rooms_list.unshift({id:null,name:"Все помещения"})
        })
      }
      // if (this.reportTab === 4) {
      //   this.$store.dispatch(reportActionTypes.salesPlanfact, {
      //     date_start: this.date.start,
      //     date_end: this.date.end,
      //   }).then((response) => {
      //     this.headers = response.headers
      //     this.report = response.sales
      //   })
      // }
    },
    select_cashbox(){
      ////console.log(this.select_cashbox)
      
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
          till_id: this.select_cashbox.serial
        }).then((resp) => {
        ////console.log(resp)
        if(resp && resp.cashbox && resp.cashbox.cashbox) {

          this.select_cashbox_id = resp.cashbox.cashbox.id

          } else {

            alert('Не удалось получить данные по выбранной кассе!')
         }
    })
    }
  }
  }
</script>
<style scoped lang="scss">
.filter {
  &.report-1 {
    width: 100%;
    display: flex;
    align-items: center;

    .left {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .right {
    }
  }

  &.report-3 {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .item {
      width: 100%;

      .v-application .primary--text {
        color: #767676 !important;
        caret-color: #767676 !important;

      }
    }
  }
}

.custom__date-button {
  width: 230px;
  height: 23px;
  display: flex;
  padding: 7px;
  max-width: 230px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess) !important;
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.special-light-button {
  box-shadow: none;
  border-radius: 12px;
  color: #1A1A1A;
  text-transform: none;
  font-size: 13px;
  line-height: 16px;

  img {
    margin-right: 9.33px;
  }
}

.border-gray {
  border: 1px solid #E0E0E0 !important;

}

.scroll-table {
  overflow-x: auto;
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
  scrollbar-width: thin;
  scrollbar-color: #E0E0E0 #fff;
  border-bottom: 1px solid #E0E0E0;

  &::-webkit-scrollbar {
    height: 12px;
    background: #E0E0E0;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #E0E0E0;
    border-radius: 8px;
    border: 2px solid #fff;
  }

  table {
    border-collapse: collapse;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    min-width: 100%;

    &#table-3 {
      min-width: 100%;

      .td-check {
        div {
          display: flex;
          align-items: center;

          svg {
            margin-right: 10px;
          }
        }
      }

      .td-client {
        div {
          white-space: nowrap;
          display: flex;
          align-items: center;

          .ava {
            width: 24px;
            min-width: 24px;
            max-width: 24px;
            height: 24px;
            min-height: 24px;
            max-height: 24px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 8px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
      }
    }

    &#table-4 {
      width: 100%;
    }

    th {
      vertical-align: top;
    }

    th,
    td {
      background: #fff;
      padding: 10px 12px;
      text-align: left;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      color: #000000;
      border: 1px solid #E0E0E0 !important;

      &.font-bold {
        font-weight: bold;
      }

      &.no-wrap {
        white-space: nowrap;
      }

      &:first-child {
        border-left: 0 !important;
      }

      &:last-child {
        border-left: 0 !important;
      }

      .open-hide {
        border: 1px solid #1A1A1A;
        width: 12px;
        height: 12px;
        display: flex;
        justify-content: center;
        border-radius: 2px;

        &::after {
          content: "+";
          line-height: 12px;
        }

        &.open {
          align-items: center;

          &::after {
            content: "";
            display: block;
            height: 1px;
            background: #1A1A1A;
            width: 6px;
            border-radius: 1px;
            line-height: 10px;
          }
        }
      }
    }

    tbody {
      tr {
        &.parrent {
          td {
            background: #F1F1F1;
          }
        }

        &:last-child {
          td {
            border-bottom: 0 !important;
          }
        }
      }
    }
  }
}
</style>